module.exports = __webpack_public_path__ + "img/schema_omi_3a.65df094d.svg";